/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'api': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M850.022 911.299H767.98c-61.993 0-105.79-34.304-105.79-111.248v-92.918c0-61.85 43.797-111.165 105.79-111.165h33.433a50.821 50.821 0 00-38.062-17.254H296.776a50.729 50.729 0 00-38.329 17.51c60.672 1.331 103.394 49.9 103.394 110.91v92.917c0 61.85-43.879 111.248-105.882 111.248h-82.002c-62.034 0-112.517-50.35-112.517-112.2v-90.931c0-61.87 50.483-112.23 112.517-112.23h15.944c14.418-45.364 56.678-78.46 106.875-78.46H474.47v-48.67h-40.755c-62.003 0-109.414-34.386-109.414-96.236V223.887c0-61.86 47.38-111.247 109.414-111.247h143.37c62.004 0 103.885 49.377 103.885 111.258v130.099c0 61.85-41.881 114.831-103.885 114.831h-46.284v48.691h232.58c50.975 0 93.932 34.1 107.685 80.59 51.968 9.87 91.494 55.408 91.494 110.12v90.931c0 61.85-50.483 112.2-112.517 112.2l-.02-.061z"/>'
  }
})
